import { config } from "../config";

const authorizationBaseUrl = config.smartRoutesAuthorizationBaseUrl;
const guideBaseUrl = config.smartRoutesGuideBaseUrl;
const planRouteBaseUrl = config.smartRoutesPlanRouteBaseUrl;

export const apiUrls = {
  authorization: {
    refreshToken: `${authorizationBaseUrl}/api/auth/refresh-token`,
    login: `${authorizationBaseUrl}/api/auth/login`,
    logout: `${authorizationBaseUrl}/api/auth/logout`,
    user: {
      create: `${authorizationBaseUrl}/api/user/create`,
      delete: `${authorizationBaseUrl}/api/user/delete`,
      update: `${authorizationBaseUrl}/api/user/update`,
      getAllFullInfoUser: `${authorizationBaseUrl}/api/user/get-all-with-full-info`,
      getUsersByUserIds: `${authorizationBaseUrl}/api/user/get-users-by-user-ids`,
    },
    position: {
      create: `${authorizationBaseUrl}/api/position/create`,
      update: `${authorizationBaseUrl}/api/position/update`,
      delete: `${authorizationBaseUrl}/api/position/delete`,
      getAll: `${authorizationBaseUrl}/api/position/get-all`,
    },
    right: {
      create: `${authorizationBaseUrl}/api/rights/create`,
      update: `${authorizationBaseUrl}/api/rights/update`,
      delete: `${authorizationBaseUrl}/api/rights/delete`,
      getAll: `${authorizationBaseUrl}/api/rights/get-all`,
    },
    status: {
      create: `${authorizationBaseUrl}/api/status/create`,
      update: `${authorizationBaseUrl}/api/status/update`,
      delete: `${authorizationBaseUrl}/api/status/delete`,
      getAll: `${authorizationBaseUrl}/api/status/get-all`,
    },
  },
  guide: {
    company: {
      getAll: `${guideBaseUrl}/api/company`,
      create: `${guideBaseUrl}/api/company`,
      update: (id) => `${guideBaseUrl}/api/company/${id}`,
      delete: (id) => `${guideBaseUrl}/api/company/${id}`,
      getById: (id) => `${guideBaseUrl}/api/container-platforms/${id}`,
    },
    container: {
      getAll: `${guideBaseUrl}/api/container`,
      getPaged: `${guideBaseUrl}/api/container/paged`,
      create: `${guideBaseUrl}/api/container`,
      update: (id) => `${guideBaseUrl}/api/container/${id}`,
      delete: (id) => `${guideBaseUrl}/api/container/${id}`,
    },
    containerPlatforms: {
      getAll: `${guideBaseUrl}/api/container-platforms`,
      getPaged: `${guideBaseUrl}/api/container-platforms/paged`,
      create: `${guideBaseUrl}/api/container-platforms`,
      update: (id) => `${guideBaseUrl}/api/container-platforms/${id}`,
      getById: (id) => `${guideBaseUrl}/api/container-platforms/${id}`,
      delete: (id) => `${guideBaseUrl}/api/container-platforms/${id}`,
    },
    counterparty: {
      getAll: `${guideBaseUrl}/api/counterparty`,
      create: `${guideBaseUrl}/api/counterparty`,
      update: (id) => `${guideBaseUrl}/api/counterparty/${id}`,
      delete: (id) => `${guideBaseUrl}/api/counterparty/${id}`,
      getById: (id) => `${guideBaseUrl}/api/counterparty/${id}`,
    },
    geofence: {
      getAll: `${guideBaseUrl}/api/geofence`,
      getPaged: `${guideBaseUrl}/api/geofence/paged`,
      create: `${guideBaseUrl}/api/geofence`,
      update: (id) => `${guideBaseUrl}/api/geofence/${id}`,
      delete: (id) => `${guideBaseUrl}/api/geofence/${id}`,
      getById: (id) => `${guideBaseUrl}/api/geofence/${id}`,
    },
    typeContainer: {
      getAll: `${guideBaseUrl}/api/type-container`,
      create: `${guideBaseUrl}/api/type-container`,
      update: (id) => `${guideBaseUrl}/api/type-container/${id}`,
      delete: (id) => `${guideBaseUrl}/api/type-container/${id}`,
      getById: (id) => `${guideBaseUrl}/api/type-container/${id}`,
    },
    typeContainerPlatforms: {
      getAll: `${guideBaseUrl}/api/type-container-platforms`,
      create: `${guideBaseUrl}/api/type-container-platforms`,
      update: (id) => `${guideBaseUrl}/api/type-container-platforms/${id}`,
      delete: (id) => `${guideBaseUrl}/api/type-container-platforms/${id}`,
      getById: (id) => `${guideBaseUrl}/api/type-container-platforms/${id}`,
    },
    typeWastes: {
      getAll: `${guideBaseUrl}/api/type-wastes`,
      create: `${guideBaseUrl}/api/type-wastes`,
      update: (id) => `${guideBaseUrl}/api/type-wastes/${id}`,
      delete: (id) => `${guideBaseUrl}/api/type-wastes/${id}`,
      getById: (id) => `${guideBaseUrl}/api/type-wastes/${id}`,
    },
    vehicle: {
      getAll: `${guideBaseUrl}/api/vehicle`,
      getPaged: `${guideBaseUrl}/api/vehicle/paged`,
      create: `${guideBaseUrl}/api/vehicle`,
      update: (id) => `${guideBaseUrl}/api/vehicle/${id}`,
      delete: (id) => `${guideBaseUrl}/api/vehicle/${id}`,
      getById: (id) => `${guideBaseUrl}/api/vehicle/${id}`,
    },
    vehicleStatus: {
      getAll: `${guideBaseUrl}/api/vehicle-status`,
      create: `${guideBaseUrl}/api/vehicle-status`,
      update: (id) => `${guideBaseUrl}/api/vehicle-status/${id}`,
      delete: (id) => `${guideBaseUrl}/api/vehicle-status/${id}`,
      getById: (id) => `${guideBaseUrl}/api/vehicle-status/${id}`,
    },
    groupGeofence: {
      getAll: `${guideBaseUrl}/api/group-geofence`,
      getPaged: `${guideBaseUrl}/api/group-geofence/paged`,
      create: `${guideBaseUrl}/api/group-geofence`,
      update: (id) => `${guideBaseUrl}/api/group-geofence/${id}`,
      delete: (id) => `${guideBaseUrl}/api/group-geofence/${id}`,
      getById: (id) => `${guideBaseUrl}/api/group-geofence/${id}`,
    },
    loadType: {
      getAll: `${guideBaseUrl}/api/load-type`,
      create: `${guideBaseUrl}/api/load-type`,
      update: (id) => `${guideBaseUrl}/api/load-type/${id}`,
      delete: (id) => `${guideBaseUrl}/api/load-type/${id}`,
      getById: (id) => `${guideBaseUrl}/api/load-type/${id}`,
    },
    garage: {
      getAll: `${guideBaseUrl}/api/garage`,
      create: `${guideBaseUrl}/api/garage`,
    },
    tbo: {
      getAll: `${guideBaseUrl}/api/tbo`,
      create: `${guideBaseUrl}/api/tbo`,
    },
  },

  mapMonitoring: {
    panelData: `${guideBaseUrl}/api/map/panel-data`,
    getCoordinatesGeofenceAndCP: `${guideBaseUrl}/api/map/coordinates`,
  },
  planRoute: {
    schedule: {
      create: `${planRouteBaseUrl}/api/schedule`,
      getAll: `${planRouteBaseUrl}/api/schedule`,
      schedulePartsByScheduleId: (cpId) =>
        `${planRouteBaseUrl}/api/schedule/${cpId}/schedule-parts`,
      getByCpId: (id) => `${planRouteBaseUrl}/api/schedule/${id}`,
    },
    cp: {
      update: (id) => `${planRouteBaseUrl}/api/plan-container-platforms/${id}`,
    },
    cpPickupPlan: {
      getAll: `${planRouteBaseUrl}/api/plan-container-platforms`,
      schedule: `${planRouteBaseUrl}/api/plan-container-platforms/schedule`,
    },
    routePlanning: {
      //Поставить задачу генерации маршрутов в очередь
      generate: `${planRouteBaseUrl}/api/route-planning/ai/generate`,
      //Утвердить вариант по дате и ключу алгоритма карточки (routeDate + algorithm из suggestions).
      approve: `${planRouteBaseUrl}/api/route-planning/ai/approve`,
      //Сохранённые предложения маршрутов на дату (без списка КП — только сводка для карточек UI).
      suggestions: `${planRouteBaseUrl}/api/route-planning/ai/suggestions`,
      /** Утверждённые маршруты на дату (полилинии для карты). Query: routeDate, опционально algorithm. */
      plannedRoutes: `${planRouteBaseUrl}/api/route-planning/planned-routes`,

      excelExport: (routeDate) =>
        `${planRouteBaseUrl}/api/route-planning/planned-routes/excel?routeDate=${routeDate}`,

      regenerate: `${planRouteBaseUrl}/api/route-planning/ai/regenerate`,
    },
  },
};
